import { c as _c } from "react/compiler-runtime";
import { FollowButton, TipButton } from '@/app/[locale]/(worlds)/[roomId]/components/InforCreatorResponsiveButtons';
import PremiumAccessButton from '@/app/[locale]/(worlds)/[roomId]/components/PremiumAccessButton';
import WorldAvatar from '@/app/[locale]/(worlds)/[roomId]/components/WorldAvatar';
import TipModal from '@/components/TipModal';
import VerifiedBadge from '@/components/VerifiedBadge';
import { useAuthContext } from '@/context/AuthContext';
import { useCheckEnterRoomContext } from '@/context/CheckEnterRoomContext';
import { useUAContext } from '@/context/UAContext';
import { useWorldCommunityContext } from '@/context/WorldCommunityContext';
import { Link } from '@/i18n/navigation';
import { hasVerifiedCreatorBadge } from '@/lib/cms';
import { useTranslations } from 'next-intl';
import { Suspense, use } from 'react';
import { useIsClient } from 'usehooks-ts';
function WorldInfoCreatorInner() {
  const $ = _c(39);
  const t = useTranslations();
  const {
    followersData
  } = useWorldCommunityContext();
  const {
    isMobileApp
  } = useUAContext();
  const isClient = useIsClient();
  const {
    currentUserId
  } = useAuthContext();
  const {
    roomData,
    isPremiumRoom,
    isVoucherCheckPassed,
    guestAccountPromise
  } = useCheckEnterRoomContext();
  const creatorAccountData = use(guestAccountPromise);
  const roomOwnerCommunityUserId = roomData.owner.community_user_id;
  const isVisitingOtherUserProfile = !!roomOwnerCommunityUserId && currentUserId !== roomOwnerCommunityUserId;
  const showFollowButton = isVisitingOtherUserProfile && !!creatorAccountData?.community_user_id;
  const showTipButton = !!creatorAccountData?.accept_tip;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <WorldAvatar />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = `/profile/${roomData.owner.community_user_id}`;
  let t2;
  if ($[1] !== roomData.owner.display_name) {
    t2 = <span className="subheader-1 min-w-0 truncate landscape:text-sm landscape:tracking-[0.22px]">{roomData.owner.display_name}</span>;
    $[1] = roomData.owner.display_name;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== roomData.owner) {
    t3 = hasVerifiedCreatorBadge(roomData.owner);
    $[3] = roomData.owner;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <VerifiedBadge isVerified={t3} />;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t1 || $[8] !== t2 || $[9] !== t4) {
    t5 = <Link href={t1} className="flex min-w-0 items-center gap-1" target="_blank">{t2}{t4}</Link>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== followersData?.totalItems || $[12] !== t) {
    t6 = t.rich("world-info.followers", {
      totalFollowers: followersData?.totalItems ?? 0
    });
    $[11] = followersData?.totalItems;
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t6) {
    t7 = <span className="body-2 text-vive-primary-30 flex items-center landscape:text-xs landscape:tracking-[0.18px]">{t6}</span>;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t5 || $[17] !== t7) {
    t8 = <div className="flex items-center gap-2 lg:gap-4">{t0}<div className="flex min-w-0 flex-col">{t5}{t7}</div></div>;
    $[16] = t5;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== showFollowButton) {
    t9 = <FollowButton showFollowButton={showFollowButton} />;
    $[19] = showFollowButton;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== roomData.hub_sid || $[22] !== roomData.owner.display_name || $[23] !== roomData.owner.htc_account_id || $[24] !== showTipButton) {
    t10 = showTipButton && <TipModal recipientName={roomData.owner.display_name} creatorId={roomData.owner.htc_account_id} worldId={roomData.hub_sid} dialogTrigger={<TipButton />} />;
    $[21] = roomData.hub_sid;
    $[22] = roomData.owner.display_name;
    $[23] = roomData.owner.htc_account_id;
    $[24] = showTipButton;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== isClient || $[27] !== isMobileApp || $[28] !== isPremiumRoom || $[29] !== isVoucherCheckPassed || $[30] !== roomData.owner.community_user_id) {
    t11 = isClient && isPremiumRoom && !isMobileApp && <PremiumAccessButton isPaid={isVoucherCheckPassed} page="detail" communityUserId={roomData.owner.community_user_id} />;
    $[26] = isClient;
    $[27] = isMobileApp;
    $[28] = isPremiumRoom;
    $[29] = isVoucherCheckPassed;
    $[30] = roomData.owner.community_user_id;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  let t12;
  if ($[32] !== t10 || $[33] !== t11 || $[34] !== t9) {
    t12 = <div className="flex items-center gap-2 lg:gap-4">{t9}{t10}{t11}</div>;
    $[32] = t10;
    $[33] = t11;
    $[34] = t9;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  let t13;
  if ($[36] !== t12 || $[37] !== t8) {
    t13 = <div data-component="world-info-creator" className="flex w-full flex-wrap items-center gap-y-4"><div className="flex items-center gap-2 lg:gap-4">{t8}{t12}</div></div>;
    $[36] = t12;
    $[37] = t8;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  return t13;
}
function WorldInfoCreator() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Suspense fallback={null}><WorldInfoCreatorInner /></Suspense>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export default WorldInfoCreator;